import { useReveal } from "../hooks/useReveal";
import { CopyImage } from "./CopyImage";
import { CopyText } from "./CopyText";

export function Dorothy() {
  const ref = useReveal<HTMLElement>();
  return (
    <section className="section section-dorothy" id="dorothy" ref={ref}>
      <div className="dor-grid">
        <div className="dor-photo">
          <CopyImage
            path="dorothy.photoUrl"
            placeholderLabel="PORTRAIT · DOROTHY ASHABA"
            altPath="dorothy.name"
          />
          <div className="photo-caption">
            <CopyText path="dorothy.photoCaption" as="span" />
          </div>
        </div>
        <div className="dor-text">
          <div className="sec-eyebrow">
            <em>
              <CopyText path="dorothy.eyebrow" as="span" />
            </em>
          </div>
          <h2 className="sec-title sec-title-sm">
            <CopyText path="dorothy.name" as="span" />
          </h2>
          <p className="lede-serif">
            <CopyText path="dorothy.lede" as="span" />
          </p>
          <blockquote className="pull-quote">
            <span className="quo-mark">“</span>
            <CopyText path="dorothy.quote" as="span" />
            <span className="quo-mark">”</span>{" "}
            <cite>
              <CopyText path="dorothy.quoteCite" as="span" />
            </cite>
          </blockquote>
        </div>
      </div>
    </section>
  );
}
